import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DeviceService } from '@core/services/util/device.service';

@Injectable({
  providedIn: 'root'
})

export class MobileGuard  {

    constructor(
        private deviceService: DeviceService,
        private router: Router
    ) {
    }

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        if(this.deviceService.isMobile()) {
            return true;
        }

        this.router.navigateByUrl('404');
        return false;
    }
}
